import React from 'react';
import { gray60 } from "../../vars.js";

const ArrowRight = ({ width = 24, height = 24, color = gray60, className }) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" lassName={className} width={width} height={height} viewBox="0 0 24 24" fill="none" stroke={color} stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" class="feather feather-chevron-left"><polyline points="15 18 9 12 15 6"></polyline></svg>
    );
};

export default ArrowRight;